module.exports = __webpack_public_path__ + "static/media/home_view_cate.a9baadae.jpg";